export default __webpack_public_path__ + "static/media/printConnect.01c78aa4.svg";